<template>
    <div>
        <form>
            <div class="lw-cols multiple-rows multiple-rows-tl multiple-rows-tp multiple-rows-sl multiple-rows-sp">
                <component v-for="field in filteredSignUpFieldsTypes"
                           :is="getFieldComponent(field)"
                           :field="field"
                           v-validate="getValidationRules(field)"
                           v-model="$data[field.target][field.key]"
                           :data-vv-as="fieldLabel(field)"
                           :error="errors.first(field.name)"
                           :key="field.name"
                           :inputClass="{'lw-brand-border': errors.first(field.name) }"></component>
            </div>

            <div v-if="responseErrors.length" class="response-errors">
                <p v-for="(error, idx) in responseErrors"
                   :key="idx"
                   class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text"
                   v-html="getErrorMessage([error])"></p>
            </div>

            <div v-if="showSubmitButtons" class="-form-login">
                <div id="submitLogin" class="-login-but form-button js-enterFocus">
                    <button @click.prevent="submit" class="btn-lbl lw-btn">
                        {{ i18n.get('common.login_create') }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import axios from "commonjs/axios";
    import {mapState} from 'vuex';
    import InputFieldComponent from "./fields/InputFieldComponent";
    import DropdownFieldComponent from "./fields/DropdownFieldComponent";
    import CheckboxComponent from "./fields/CheckboxComponent";
    import TermsComponent from "./fields/TermsComponent";
    import AuthenticationMixin from "./AuthenticationMixin";

    export default {
        name: "RegisterComponent",

        data() {
            return {
                form: {},
                customFields: {},
                responseErrors: []
            }
        },
        props: {
            successCallback: {
                type: Function,
                default: (redirectUrl) => {
                    window.location.replace(redirectUrl);
                }
            },
            showSubmitButtons: {
                type: Boolean,
                default: true
            },
            withoutTerms: {
                type: Boolean,
                default: false
            },
            withoutMarketingOptIn: {
                type: Boolean,
                default: false
            },
            onlyRequiredFields: {
                type: Boolean,
                default: false
            },
            additionalAuthenticatonFormData: {
                type: Boolean,
                default() {
                    return {};
                }
            }
        },
        computed: {
            ...mapState([
                'userSignUpFields'
            ]),
            filteredSignUpFields() {
                return this.userSignUpFields.filter(field => {
                    if (this.withoutTerms && field.name === 'terms') {
                        return false;
                    }
                    
                    if (this.withoutMarketingOptIn && field.name === 'optin') {
                        return false;
                    }

                    if (this.onlyRequiredFields && !field.required) {
                        return false;
                    }
                    return true;
                });
            },
            
            filteredSignUpFieldsTypes() {
                return this.filteredSignUpFields.map(field => {
                    return {
                        ...field,
                        target: field.customField ? 'customFields' : 'form',
                        key: field.key ? field.key : field.name
                    }
                })
            }
        },
        methods: {
            submit() {
                this.addGDPRData();
                return new Promise((resolve, reject) => {
                    this.$validator.validateAll().then(result => {
                        if (!result) {
                            return reject();
                        }
                        
                        axios.post(`${this.clientURL}/api/users`, {
                            ...this.form,
                            'custom_fields': {
                                ...this.customFields
                            }
                        }).then(response => {
                            if (response.data.success) {
                                this.successCallback(response);
                                resolve();
                            } else {
                                this.responseErrors = response.data.errors;
                                reject();
                            }
                        }).catch(error => {
                            reject();
                            console.log(error);
                        })
                    }).catch(() => {
                        reject();
                    });


                });
            },
            authenticate() {
                return this.submit();
            },

            getValidationRules(field) {
                //Todo: add more validations based on the type eg email
                const rules = [];
                if (field.required) {
                    rules.push('required');
                }
                if (field.type == 'email') {
                    rules.push('email');
                }
                if (field.type == 'password') {
                    rules.push('min:6');
                }
                return rules.join('|');
            },

            getFieldComponent(field) {
                switch (field.type) {
                    case 'terms':
                        return 'TermsComponent';
                    case 'checkbox':
                        return 'CheckboxComponent';
                    case 'dropdown':
                        return 'DropdownFieldComponent';
                    default:
                        return 'InputFieldComponent';
                }
            },

            fieldLabel(field) {
                return (field.translationKey) 
                    ? this.i18n.get(field.translationKey) 
                    : field.name;
            },

            addGDPRData() {
                //Check if the user has selected the dataprotection options and add it to the registration data
                if (typeof window.dpModalRenderer != 'undefined' && window.dpModalRenderer.userSelectedCookieSettings()) {
                    this.form['data_protection_cookie_settings'] = window.dpModalRenderer.getCookieSettings();
                }
                if (typeof window.DP_EU != 'undefined') {
                    this.form['eu_customer'] = window.DP_EU;
                }
            },

            getErrorMessage(error) {
                return window.getErrorMessage(error);
            },
            
            formField(field) {
                console.log(field); 
                
                if (field.customField) {
                    return this.$data.customFields[field.key];
                }
                
                return this.$data.form[field.name];
            }
        },

        components: {
            InputFieldComponent,
            DropdownFieldComponent,
            CheckboxComponent,
            TermsComponent
        },
        watch: {
            additionalAuthenticatonFormData: {
                immediate: true,
                handler(value) {
                    this.form = {
                        ...this.form,
                        ...value
                    }
                }
            },
        },

        mixins: [
            AuthenticationMixin
        ],
    }
</script>
